import Swiper, { Keyboard, Navigation, Autoplay } from 'swiper';
import SwiperCore from 'swiper';

export function secondProductSlider() {
  const $slider = $('.second-slider-product');
  if (!$slider || $slider.length === 0) return;

  SwiperCore.use([Navigation, Keyboard, Autoplay]);

  const swiper = new Swiper('.second-slider-product ', {
    navigation: {
      nextEl: '.product-next',
      prevEl: '.product-prev',
    },

    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    speed: 1000,

    loop: true,

    roundLengths: true,

    observer: true,
    observeParents: true,

    watchSlidesProgress: true,

    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 30,
      },
    },

    on: {
      init(swiper) {
        swiper.update();
      },
    },
  });
}